module.exports = __webpack_public_path__ + "static/partnership_img2@2x-d96b2a7d443d9da83d67ac2777cf84bb.jpg";